export default "__VITE_ASSET__CIWXiWOD__"